import type {
  ShiftEmployeeDirectoryManagerRow,
  ShiftEmployeeDirectoryWorkerRow,
  ShiftEmployeeSex,
} from '../../models/employees.types';
import { type EmployeeFormState } from '../../components/EmployeeFormFields/employee-form.types';
import { type SortField, type SortDirection } from './employees-page.types';

export const SORT_FIELD_LABELS = {
  firstName: 'שם פרטי',
  lastName: 'שם משפחה',
} as const;

export const createEmptyEmployeeForm = (): EmployeeFormState => ({
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  sex: '',
  birthdate: '',
  idNumber: '',
  sectionPk: '',
});

export const SEX_LABELS: Record<ShiftEmployeeSex, string> = {
  male: 'זכר',
  female: 'נקבה',
};

export const isManagerEmployeeRow = (
  row: ShiftEmployeeDirectoryManagerRow | ShiftEmployeeDirectoryWorkerRow,
): row is ShiftEmployeeDirectoryManagerRow => 'employeePk' in row;

export const normalizeSearchText = (value: string): string => value.trim().toLocaleLowerCase('he-IL');

export const compareByField = (
  left: ShiftEmployeeDirectoryManagerRow | ShiftEmployeeDirectoryWorkerRow,
  right: ShiftEmployeeDirectoryManagerRow | ShiftEmployeeDirectoryWorkerRow,
  field: SortField,
  direction: SortDirection,
): number => {
  const leftValue = left[field].toLocaleLowerCase('he-IL');
  const rightValue = right[field].toLocaleLowerCase('he-IL');
  const comparison = leftValue.localeCompare(rightValue, 'he-IL');
  return direction === 'asc' ? comparison : comparison * -1;
};

export const formatSexLabel = (sex: ShiftEmployeeSex | null): string => {
  if (!sex) {
    return '—';
  }

  return SEX_LABELS[sex] ?? sex;
};
